import rulesFunctions from '@/store/composables/document-rules';
import store from '@/store';

export function buildRules(field, appliedRules) {
  const { rules } = field.validation;

  rules.forEach((rule) => {
    if (rulesFunctions[rule.type]) {
      appliedRules[rule.type] = rulesFunctions[rule.type].default();
    }

    store.dispatch(
      'Document/addFieldRule',
      Object.assign({}, rule, { fieldName: field.name })
    );
  });
}

export function checkRules(field, fieldRules, appliedRules) {
  const rules = fieldRules[field.name];
  if (rules) {
    const rulesIndexed = {};
    Object.keys(rules).forEach((target) => {
      const fieldRules = rules[target];

      fieldRules.forEach((fieldRule) => {
        rulesIndexed[fieldRule.type] = rulesIndexed[fieldRule.type] || [];
        rulesIndexed[fieldRule.type].push({
          value: store.getters['Document/getFieldValue'](target),
          rule: fieldRule,
        });
      });
    });
    Object.keys(rulesIndexed).forEach((rule) => {
      appliedRules[rule] = rulesFunctions[rule].apply(rulesIndexed[rule]);
      field.appliedRules[rule] = appliedRules[rule];
      store.dispatch('setFieldRules', field);
    });
  }
}
